import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonMenuComponent } from '@shared/components/button-menu/button-menu.component';
import { MenuItem } from 'primeng/api';
import {
  DFP_MODULE_LABELS,
  DFP_MODULE_ORDER,
  DfpModuleKey,
  DfpModulesState,
} from '@features/dashboard/performance/pages/dfp/services/dfp-modules.state';

/**
 * Barra "Mostrar" da aba Demonstrativos (card 3801, protótipo `opcao-a`): um interruptor em pílula por módulo.
 * Ligado = pílula navy com check; desligado = branca com +. Pode desligar todos (a aba mostra o estado vazio). O
 * estado vive no `DfpModulesState`, provido pelo `DfpComponent`.
 */
@Component({
  selector: 'app-dfp-module-toggles',
  templateUrl: './module-toggles.component.html',
  styleUrls: ['./module-toggles.component.scss'],
  imports: [ButtonMenuComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DfpModuleTogglesComponent {
  protected readonly modules = inject(DfpModulesState);
  protected readonly keys = DFP_MODULE_ORDER;
  protected readonly labels = DFP_MODULE_LABELS;

  /** Opções do "Restaurar padrão": só o tamanho, ou tamanho e módulos padrão juntos. */
  protected readonly restoreItems: MenuItem[] = [
    {
      label: 'Tamanho dos cards e colunas',
      icon: 'pi pi-arrows-h',
      title: 'Divisão dos cards em metade e metade e colunas no tamanho automático',
      command: () => this.modules.resetSizes(),
    },
    {
      label: 'Visão completa',
      icon: 'pi pi-th-large',
      title: 'DRE, Balanço e Pontos de destaque ligados, com o tamanho padrão',
      command: () => this.modules.restoreFullView(),
    },
  ];

  protected titleFor(key: DfpModuleKey): string {
    return this.modules.isOn(key) ? `Esconder ${this.labels[key]}` : `Mostrar ${this.labels[key]}`;
  }
}
